
import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface AppPreviewFloatingBadgeProps {
  position: string;
  delay: number;
  icon: ReactNode;
  title: string;
  description: string;
}

export function AppPreviewFloatingBadge({ 
  position, 
  delay, 
  icon, 
  title, 
  description 
}: AppPreviewFloatingBadgeProps) {
  const getPositionClasses = () => {
    switch (position) {
      case 'left-top':
        return 'absolute -left-16 top-20';
      case 'right-middle':
        return 'absolute -right-10 top-52';
      case 'left-bottom':
        return 'absolute -left-20 bottom-20';
      // Mobile-specific positions
      case 'left-top-mobile':
        return 'absolute -left-4 top-8 scale-75 origin-left';
      case 'right-middle-mobile':
        return 'absolute -right-4 top-32 scale-75 origin-right';
      case 'left-bottom-mobile':
        return 'absolute -left-8 bottom-12 scale-75 origin-left';
      default:
        return 'absolute -left-16 top-20';
    }
  };

  return (
    <motion.div 
      className={`${getPositionClasses()} bg-white shadow-lg rounded-xl p-2 md:p-4 flex items-center space-x-2 md:space-x-3 z-20`}
      initial={{ x: position.includes('left') ? 40 : -40, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay, duration: 0.7 }}
    >
      <div className="bg-indigo-100 text-indigo-600 p-1.5 md:p-2 rounded-full">
        {icon}
      </div>
      <div>
        <h4 className="font-semibold text-gray-900 text-xs md:text-sm">{title}</h4>
        <p className="text-2xs md:text-xs text-gray-500">{description}</p>
      </div>
    </motion.div>
  );
}
